import propTypes from 'prop-types';

const singleFitmentProduct = propTypes.shape({
  id: propTypes.number,
  sku: propTypes.string,
  productType: propTypes.string,
  modelName: propTypes.string,
  modelNameShort: propTypes.string,
  longDescription: propTypes.string,
  images: propTypes.arrayOf(propTypes.shape({
    url: propTypes.string,
  })),
  manufacturer: propTypes.shape({
    name: propTypes.string,
    logo: propTypes.string,
  }),
  productDetails: propTypes.shape({
    size: propTypes.string,
    features: propTypes.arrayOf(propTypes.string),
    price: propTypes.objectOf(propTypes.number),
    performanceRatings: propTypes.arrayOf(propTypes.shape({
      name: propTypes.string,
      description: propTypes.string,
      value: propTypes.oneOfType([
        propTypes.number,
        propTypes.string,
      ]),
    })),
    specifications: propTypes.arrayOf(propTypes.shape({
      name: propTypes.string,
      value: propTypes.string,
    })),
  }),
});

export const productPropType = propTypes.oneOfType([
  singleFitmentProduct,
  propTypes.shape({
    splitFitment: propTypes.bool,
    frontTire: singleFitmentProduct,
    rearTire: singleFitmentProduct,
  }),
]);
